import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Footer } from "./partials/Footer";
import {Navbar} from './partials/Navbar';
import RouterPage from "./RouterPage";

function App() {
  return (
    <Router> 
          <Navbar />
          <RouterPage />
          <Footer />
    </Router>
  );
}

export default App;
